/** Matches Button `size="default"` — use on inputs, select triggers, date/time pickers. */
export const formControlHeightClass = "h-8";

/** Matches Button `size="sm"`. */
export const formControlHeightSmClass = "h-7";

/** Matches Button `size="lg"`. */
export const formControlHeightLgClass = "h-9";

/** Destructive border + ring for required, enabled, editable, empty field controls (composite triggers). */
export const requiredFieldBorderClass =
    "border-destructive ring-3 ring-destructive/20 dark:border-destructive/50 dark:ring-destructive/40";

/** Tailwind variants for native `required` on shadcn form primitives — only when empty (`:invalid`). */
export const requiredFieldPrimitiveClasses =
    "required:not(:disabled):not([readonly]):invalid:border-destructive required:not(:disabled):not([readonly]):invalid:ring-3 required:not(:disabled):not([readonly]):invalid:ring-destructive/20 dark:required:not(:disabled):not([readonly]):invalid:border-destructive/50 dark:required:not(:disabled):not([readonly]):invalid:ring-destructive/40 read-only:border-input read-only:ring-0 dark:read-only:border-input";

/** Ring-based required indicator for legacy select triggers that use inset ring instead of border. */
export const requiredFieldRingClass =
    "ring-destructive/80 dark:ring-destructive/50";

export function requiredFieldBorderWhen(
    isRequired: boolean | undefined,
    enabled = true,
    editable = true,
    isEmpty = true,
): string {
    return isRequired && enabled && editable && isEmpty ? requiredFieldBorderClass : "";
}

export function requiredFieldRingWhen(
    isRequired: boolean | undefined,
    isEmpty = true,
    enabled = true,
): string {
    return isRequired && enabled && isEmpty ? requiredFieldRingClass : "ring-border";
}
